<template>
	<h1
		class="text-label-primary font-squad truncate px-4 text-[28px] leading-9 font-black uppercase"
	>
		<slot />
	</h1>
</template>
